module.exports = __webpack_public_path__ + "static/media/mutum.acf9e41a.mp3";